export enum D365ConfirmationType {
    CheckDOI = 100000000,
    CheckCall = 100000001,
    TacitApprovalSMS = 100000002,
    NessunaConferma = 100000003,
}
